import React from "react";
import { Link } from "react-router-dom";

export default function GoodPractices(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Promoting Good Practices
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            Child abuse, particularly sexual abuse, can impact the child’s
            physical, social, psychological and mental health. Abuse can occur
            within many situations including at home, school and in a sporting
            environment. SS/KVS staff, especially those working as coach,
            instructor, teacher, official or volunteer have regular contact with
            children and shall serve as an important link in identifying cases/
            situations where children need safeguarding and protection. They
            shall immediately report all suspicious cases of poor practice and
            child abuse by following the laid down guidelines in this regard.
          </span>
          <span className="text-gray-700 block mb-4">
            All SS/KVS staff shall demonstrate exemplary behavior in order to
            promote children’s welfare and reduce the likelihood of incidents of
            child abuse. There should be a constant endeavor to create a
            positive environment and culture by adopting good practices and
            shunning bad practices. An illustrative list of ‘Good Practices
            (Always Adopt)’and ‘Prohibited Practices (Never Adopt)’ are
            contained in{" "}
            <Link
              to="/csppolicy/annexure2"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-yellow-500 hover:underline"
            >
              Annexure-2
            </Link>{" "}
            and{" "}
            <Link
              to="/csppolicy/annexure3"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-yellow-500 hover:underline"
            >
              Annexure-3
            </Link>{" "}
            respectively of this Policy.
          </span>
          <span className="text-gray-700 block mb-1">
            DeafKidz International’s guidelines on ‘Safeguarding deaf children’
            are placed at{" "}
            <Link
              to="/csppolicy/annexure4"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-yellow-500 hover:underline"
            >
              Annexure-4
            </Link>{" "}
            which may be followed by SS/KVS staff when engaging with the deaf
            children
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Practices to be Avoided
          </h2>
          <span className="text-gray-700 block mb-1">
            The following should be <b>avoided except in emergencies.</b>{" "}
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                spending time alone with child
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                bringing or dropping off a child alone.
              </span>
            </li>
          </ul>
          <span className="text-gray-700 block mb-1">
            If need arises where these situations are unavoidable (for example,
            where a child sustains an injury and needs to be taken to hospital,
            or a parent fails to arrive to pick a child up at the end of a
            session) it should be with the full knowledge and consent of someone
            in charge in the organization or the child’s parents.
          </span>
        </div>
      </div>
    </div>
  );
}
